export default "__VITE_ASSET__80ac50d3__"